/*
* Ferguson Finch "Notify me when it's back".
*
* On product pages the theme fires `theme:variant:change` (assets/theme.dev.js,
* fireHookEvent) whenever a size or colour is picked. When the picked variant is
* sold out we show the button; it opens a small email form that is sent to the
* Ferguson Finch Wishlist app at /apps/wishlist/restock. The app emails the
* customer once that variant is back in stock.
*
* Markup comes from snippets/restock-form.liquid:
*   [data-restock][data-variant-id]   wrapper, hidden while the variant is in stock
*   [data-restock-toggle]             opens / closes the form
*   [data-restock-form]               email form
*/

(function() {
  if (window.FFRestockLoaded) return;
  window.FFRestockLoaded = true;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function update(wrapper, variant) {
    if (!variant) return;
    var changed = wrapper.dataset.variantId !== String(variant.id);
    wrapper.dataset.variantId = String(variant.id);
    wrapper.hidden = variant.available !== false;

    var size = wrapper.querySelector('[data-restock-size]');
    if (size) size.textContent = optionsText(wrapper, variant);

    // A different size starts with a fresh form, so a "Thanks" from the last one doesn't linger.
    if (changed) reset(wrapper);
  }

  // "Shoe size: 7", or "Colour: Black · Size: 10" for products with more than one option.
  function optionsText(wrapper, variant) {
    if (variant.title === 'Default Title') return '';
    var names = [];
    try { names = JSON.parse(wrapper.dataset.optionNames || '[]'); } catch (e) {}
    var values = variant.options || [];
    if (!values.length || names.length !== values.length) return variant.title;
    return values.map(function(value, i) { return names[i] + ': ' + value; }).join(' · ');
  }

  function reset(wrapper) {
    var form = wrapper.querySelector('[data-restock-form]');
    var message = wrapper.querySelector('[data-restock-message]');
    var submit = wrapper.querySelector('[data-restock-submit]');
    var row = wrapper.querySelector('.restock__row');
    var optin = wrapper.querySelector('.restock__optin');
    if (form) form.classList.remove('is-done');
    if (row) row.hidden = false;
    if (optin) optin.hidden = false;
    if (submit) submit.disabled = false;
    if (message) {
      message.hidden = true;
      message.textContent = '';
    }
  }

  function toggle(wrapper) {
    var button = wrapper.querySelector('[data-restock-toggle]');
    var form = wrapper.querySelector('[data-restock-form]');
    var open = form.hidden;
    form.hidden = !open;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var email = form.querySelector('[data-restock-email]');
      if (email && !email.value) email.focus();
    }
  }

  function showMessage(wrapper, text, isError) {
    var message = wrapper.querySelector('[data-restock-message]');
    message.textContent = text;
    message.classList.toggle('is-error', !!isError);
    message.hidden = false;
  }

  function submit(wrapper, form) {
    var email = form.querySelector('[data-restock-email]');
    var trap = form.querySelector('.restock__trap');
    var newsletter = form.querySelector('[data-restock-newsletter]');
    var button = form.querySelector('[data-restock-submit]');
    var value = (email.value || '').trim();

    if (!EMAIL.test(value)) {
      showMessage(wrapper, 'Please enter a valid email address.', true);
      email.focus();
      return;
    }

    button.disabled = true;
    fetch(wrapper.dataset.proxyUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        variantId: wrapper.dataset.variantId,
        email: value,
        newsletter: !!(newsletter && newsletter.checked),
        website: trap ? trap.value : ''
      })
    }).then(function(res) {
      return res.json().catch(function() { return {}; }).then(function(data) {
        if (!res.ok) throw new Error(data.error || res.status);
        return data;
      });
    }).then(function() {
      form.classList.add('is-done');
      form.querySelector('.restock__row').hidden = true;
      var optin = form.querySelector('.restock__optin');
      if (optin) optin.hidden = true;
      showMessage(wrapper, wrapper.dataset.successText, false);
    }).catch(function(error) {
      console.warn('Back in stock signup failed', error);
      button.disabled = false;
      var text = String(error.message) === 'in_stock'
        ? 'Good news, this is back in stock now. Please refresh the page.'
        : wrapper.dataset.errorText;
      showMessage(wrapper, text, true);
    });
  }

  function init() {
    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail && event.detail.variant;
      var scope = event.target && event.target.querySelectorAll ? event.target : document;
      scope.querySelectorAll('[data-restock]').forEach(function(wrapper) { update(wrapper, variant); });
    });

    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-restock-toggle]');
      if (!button) return;
      event.preventDefault();
      toggle(button.closest('[data-restock]'));
    });

    document.addEventListener('submit', function(event) {
      var form = event.target.closest('[data-restock-form]');
      if (!form) return;
      event.preventDefault();
      submit(form.closest('[data-restock]'), form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
